import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DropResourceApiModel, ResourceFolderApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ResourceFoldersService {
  public apiUrl = 'resource-folders';

  constructor(private readonly http: HttpClientService) {}

  public add(model: ResourceFolderApiModel): Observable<ResourceFolderApiModel> {
    return this.http.post<ResourceFolderApiModel>(`${this.apiUrl}/add`, model);
  }

  public update(model: ResourceFolderApiModel): Observable<ResourceFolderApiModel> {
    return this.http.put<ResourceFolderApiModel>(`${this.apiUrl}/update`, model);
  }

  public delete(id: string): Observable<Array<ResourceFolderApiModel>> {
    return this.http.delete<Array<ResourceFolderApiModel>>(`${this.apiUrl}/delete/${id}`);
  }

  public move(model: DropResourceApiModel): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/drop`, model);
  }
}
